import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _FixedAssetItem } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { SelectStoreEditor } from "../../SelectStore.editor";
import { FixedAssetLineEditor } from "../../../../../../editor/fixedAssets/FixedAssetLine.editor";
import { SelectFixedAsset } from "../FixedAsset/SelectFixedAsset";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { DropDown } from "../../../../../../theme/Component/DropDown";
import AutoChart from "../../../../../../../core/graph/AutoChart";
import useModal, { MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";



export const FixedAssetItemByEmployee = () => {

    const entailment = useDataBean(_FixedAssetItem);
    const single = Singleton.getInstance();
    const [Account, setAccount] = useState<number>(null)
    const [storeID, setstoreID] = useState<number>(null)
    const [idLine, setidLine] = useState<number>(null)
    const [ticketCode, setticketCode] = useState<any>(null)
    const [filter, setfilter] = useState<any>(null)
    const [form, setform] = useState<any>({
        Name: null,
        asset: null,
        placa: null
    })
    const [idFixedAsset, setidFixedAsset] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [listaAll, setListaAll] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    const modalGraph = useModal("Grafica", MODAL_XL);

    useEffect(()=>{
        getLista(); 
    },[paginador.page])

    const getLista = () => {
        if (!Account) {
            toast.warn("Debe seleccionar un Tercero  antes de continuar.");
            return;
        }

        entailment.instance.getFixedAssetItemsByEmployee(
            Account,
            storeID,
            null,
            idLine,
            form.asset,
            ticketCode,
            filter,
            paginador.page,
            15
        ).then((resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                setLista(resp.List);
            }
        }).catch((err: any) => {
            toast.error(err);
        });
    };
    const getListaAll = () => {
        if (!Account) {
            toast.warn("Debe seleccionar un Tercero  antes de continuar.");
            return;
        }

        entailment.instance.getFixedAssetItemsByEmployee(
            Account,
            storeID,
            null,
            idLine,
            form.asset,
            ticketCode,
            filter,
            null,
            null
        ).then((resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                setListaAll(resp.List);
            }
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const create = () => {
        entailment.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        entailment.deleteItemVoid(entailment.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        entailment.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta', property: 'AccountantIDStr', visible: false },
        { title: 'Core de Negocio', property: 'BusinessCoreName', visible: false },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Causa de la Baja', property: 'ItemDownCauseName', visible: true },
        { title: 'Tiempo Depreciación', property: 'DepreciationTime', visible: true },
        { title: 'Tiempo Depreciación Fiscal', property: 'FiscalDepreciationTime', visible: true },
        { title: 'Adición NIIF', property: 'NiifAdditionValue', visible: true },
        { title: 'Adición Fiscal', property: 'FiscalAdditionValue', visible: true },
        { title: 'Reconocimiento NIIF Inicial', property: 'NiifInitialValue', visible: true },
        { title: 'Valor Residual', property: 'ResidualValue', visible: true },
        { title: 'Usar Cuenta Servicio en Ops NIIF', property: 'UseBrandIDForAllOps', visible: true },
        { title: 'No depreciar ni amortizar', property: 'NotDepreciateOrAmortize', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Estado', property: 'StateName', visible: false },
        { title: 'Valor Activo', property: 'AssetValue', visible: false },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: false },
        { title: 'Valor Depreciacion', property: 'DepreciationValue', visible: false },
        
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${entailment.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
     const actionsDropDown = [
                { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
            ];
            const buttons = () => {
                return (
                    <div className="row">
                        <div className="col-md-12">
                            <DropDown lista={actionsDropDown} eventClick={(e) => {
                                if (e.id == 1) {
                                    modalGraph.open();
                                    getListaAll();
                                }
                            }}></DropDown>
                        </div>
                    </div>
                )
            }


    return (
        <BasicPage titulo="Activos Fijos por Responsable">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Tercero / Responsable*" />
                </div>
                <div className="col-md-4">
                    <SelectStoreEditor label='Almacén/Bodega' idSelector={storeID} onChange={(e) => { setstoreID(e.IDStore) }} />
                </div>
                <div className="col-md-4">
                    <SelectFixedAsset render={form.Name} idSelector={form.asset} onChange={(e) => { setform({ ...form, "asset": e.IDFixedAsset, "Name": e.Description }) }} label="Activo Fijo" returnType="Object" />
                </div>
                <div className="col-md-4">
                    <FixedAssetLineEditor label="Grupo/Línea de Activos Fijos" idSelector={idLine} onChange={(e) => { setidLine(e.IDLine) }} />
                </div>
                <div className="col-md-4">
                    <label>Placa</label>
                    <input type="text" name="ticketCode" className="form-control" value={ticketCode} onChange={(e) => { setticketCode(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="ticketCode" className="form-control" value={filter} onChange={(e) => { setfilter(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton
                        icon="ri-send-plane-fill"
                        clase="primary"
                        eventClick={getLista}
                        disable={!Account}
                        
                    >
                        Buscar por Filtros*
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={entailment.setBean} pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                        </div>
                    </Modal>
                     <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={listaAll} head={head} useIndexAsXLabel={true}
                            xOptions={['Name', 'AccountantIDStr','BusinessCoreName','StateName']}
                            yOptions={[,'DepreciationValue','UnitaryValue','UnitaryValue','Name']} />

                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {entailment.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}